import React, {useEffect} from 'react';
import {
    View,
    Text,
    Image,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    Platform,
    Linking
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/simulacaoSucessoStyles';
import { useLogScreen } from '../useLogScreen';
export default function SimuladorDeCreditoDownloadWeb({route}) {
    useLogScreen('BaixarSimulacao');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Baixar Simulação';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const {  imprimir_link } = route.params || {};

    return (
        <BaseWeb>
            {(userInfo) => (
                <KeyboardAvoidingView
                    style={{ flex: 1 }}
                    behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                    enabled={Platform.OS !== 'web'}
                >
                    <ScrollView contentContainerStyle={styles.container}>
                        <Image
                            source={require('../assets/img/stape6_laranja.png')}
                            style={styles.image}
                            resizeMode="contain"
                        />

                        <Text style={styles.title}>Simulação enviada para o e-mail</Text>
                        <Text style={styles.subtext}>Sua simulação de financiamento foi gerada com sucesso e enviada para o e-mail {userInfo.email}. Caso prefira, você pode baixá-la usando o botão abaixo.</Text>

                        <TouchableOpacity onPress={() => navigation.navigate('HomeWeb')}>
                            <Text style={styles.linkText}>Continuar</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.button}  onPress={() => Linking.openURL(imprimir_link)}>
                            <Text style={styles.buttonText}>Baixar simulação</Text>
                        </TouchableOpacity>
                    </ScrollView>
                </KeyboardAvoidingView>
            )}
        </BaseWeb>
    );
}
